export const PARTNERS_META = {
  en: {
    title: "Partners, Memberships & Press | Perceptica",
    description: "Perceptica's research partnerships, industry memberships and press kit: company boilerplate, logo downloads, a press contact and our latest reports.",
    crumb: "Partners & Press",
  },
  bg: {
    title: "Партньори, членства и медии | Perceptica",
    description: "Изследователските партньорства, членствата и прес материалите на Perceptica: описание на компанията, лога за изтегляне, контакт за медии и доклади.",
    crumb: "Партньори и медии",
  },
} as const;
